/**
 * Assureur émetteur de l'attestation Carte Brune (colonne texte `assureurDeclarant`).
 *
 * C'est la compagnie qui a émis la Carte Brune, c'est-à-dire l'assureur principal :
 * l'agent la saisissait deux fois, à l'étape Contexte en texte libre puis à l'étape
 * Contrat dans la liste. La saisie libre laissait « SUNU ASSURANCE » sans pays, alors
 * que la compagnie existe au Burkina et au Togo. La valeur se déduit désormais de
 * l'assureur principal.
 *
 * Exception : un dossier existant (reprise notamment) dont l'assureur principal n'a
 * pas changé garde sa valeur enregistrée - elle vient du fichier d'origine et peut
 * légitimement différer du libellé du référentiel.
 */
export function assureurEmetteur(valeurs, organismes = []) {
  const saisi = valeurs.assureurDeclarant?.trim() || null;
  const principal = organismes.find(o => o.organismeTrackingId === valeurs.organismeMembreTrackingId);
  if (!principal) return saisi;
  const inchange = valeurs.organismeMembreInitialTrackingId
    && valeurs.organismeMembreInitialTrackingId === valeurs.organismeMembreTrackingId;
  if (inchange && saisi) return saisi;
  return principal.raisonSociale || saisi;
}
